module.exports = __webpack_public_path__ + "static/media/400153_01.c6c08eca.png";